import * as React from 'react';
import { connect } from 'react-redux';

import {
    getClientId,
    getLanguage,
    getBaseUrl
} from '../reducers/config';

import { getMatchIdByChannelId } from '../reducers/timings';

import { getActiveChannelId } from '../reducers/gui';

import {
    getPlayerIdsByMatchId,
    getTeamNamesByMatchId
} from '../reducers/matches';

import PlayerNamesPresentation from '../presentations/PlayerNames/PlayerNamesPresentation';
import { getFlagUrl } from '../api/assetUrls';

const mapStateToProps = (state:any) => {
    const activeChannelId:number = getActiveChannelId(state);
    const activeMatchId:number = getMatchIdByChannelId(state, activeChannelId);

    const baseUrl:string = getBaseUrl(state);
    const clientId:number = getClientId(state);

    const playerIds:any = getPlayerIdsByMatchId(state, activeMatchId);

    return {
        names: getTeamNamesByMatchId(state, activeMatchId),
        flags: {
            home: `${getFlagUrl(baseUrl, clientId, playerIds['home'])}`,
            away: `${getFlagUrl(baseUrl, clientId, playerIds['away'])}`
        }
    };
};

export default connect(mapStateToProps)(PlayerNamesPresentation);
